<document-upload-desktop
  [attachmentName]="attachmentName"
  [attachmentTypeName]="attachmentTypeName"
  [attachmentHint]="attachmentHint"
  [id]="
    document.rootEntityType +
    '-' +
    document.rootEntityId +
    '-' +
    document.relatedEntityType +
    '-' +
    document.relatedEntityId +
    '-' +
    document.type +
    (document.id ? '-' + document.id : '')
  "
  [canUploadDocuments]="isCanUploadDocuments"
  [canRemoveDocuments]="isCanRemoveDocuments"
  [uploadedDocument]="document"
  [isRequired]="isRequiredDocument"
  [isLoading]="isLoading"
  [isStripeLayout]="true"
  [isStretched]="true"
  (upload)="openPunModal($event)"
  (remove)="onRemoveFile($event)"
  (stateUpdate)="onStateUpdate($event)"
></document-upload-desktop>

<ng-template [ngIf]="!document?.id && false">
  <a type="button" class="btn btn-link download-link mb-1" [href]="POA_FILE_URL" download>
    <span class="download-icon-container">
      <icon-download></icon-download>
    </span>
    {{ "BUTTON.DOWNLOAD_PUN" | translate }}
  </a>
  <div class="helper-form-control mb-2" [innerHTML]="'FORM_HELPER.ENTRY_PUN' | translate"></div>
</ng-template>

<custom-modal [(open)]="isOpenPunModal" [header]="'DOCUMENTS.UPLOAD_PUN_TO_COMPANY_MODAL.HEADER'">
  {{ "DOCUMENTS.UPLOAD_POA_TO_COMPANY_MODAL.BODY" | translate }}

  <button footer-action type="button" class="btn btn-primary" (click)="onUploadPunFile(true)">{{ "LABELS.YES" | translate }}</button>
  <button footer-action type="button" class="btn btn-secondary" (click)="onUploadPunFile(false)">{{ "LABELS.NO" | translate }}</button>
</custom-modal>
